import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ad51e40c&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ad51e40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad51e40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad51e40c')) {
      api.createRecord('ad51e40c', component.options)
    } else {
      api.reload('ad51e40c', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ad51e40c&scoped=true&", function () {
      api.rerender('ad51e40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sOpPeBDeLKWt/JS/comp/CookieBox.vue"
export default component.exports